import React from 'react';
import styled from 'styled-components';
import plusSvg from 'assets/icon/plus.svg';
import SVG from 'react-inlinesvg';

type Position = 'left' | 'center';

type AddButtonProps = {
  label?: string;
  handleClickAdd: () => void;
  editable?: boolean;
  id?: string;
  position?: Position;
};
const Button = styled.button`
  background: transparent;
  border: none;
`;
const TextEditable = styled.div`
  cursor: pointer;
  span {
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
    margin-left: 6px;
    color: #5cabdd;
  }
`;
const AddButton = ({ label, handleClickAdd, id, position = 'center' }: AddButtonProps) => {
  return (
    <TextEditable
      className={`w-100 d-flex m-1 ${position === 'center' ? 'justify-content-center' : ''}`}
    >
      <Button onClick={() => handleClickAdd()} id={id} type="button">
        <SVG src={plusSvg} />
        <span>{label}</span>
      </Button>
    </TextEditable>
  );
};
export default AddButton;
